import { Component, ViewChild, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Router } from '@angular/router';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import { AuthService } from '@auth0/auth0-angular';

import { ChatComponent } from '../../../chat/chat.component';
import { SidebarComponent } from '../../sidebar/sidebar.component';

@Component({
  selector: 'app-chat-shell',
  standalone: true,
  imports: [
    CommonModule,
    MatIconModule,
    MatButtonModule,
    SidebarComponent,
    ChatComponent,
  ],
  templateUrl: './chat-shell.component.html',
  styleUrl: './chat-shell.component.scss',
})
export class ChatShellComponent {
  @ViewChild(ChatComponent) private chatComponent?: ChatComponent;
  @ViewChild(SidebarComponent) private sidebarComponent?: SidebarComponent;
  debugId: string | null = null;
  protected auth = inject(AuthService);

  constructor(
    private router: Router,
  ) {}

  onNewChat() {
    this.debugId = null;
    this.chatComponent?.resetConversation();
    this.sidebarComponent?.loadTasks();
    this.router.navigate(['/chat']);
  }

  onTaskSelected(conversationId: string): void {
    this.debugId = null;
    console.log(conversationId);
    this.chatComponent?.loadConversation(conversationId);
    this.router.navigate(['/chat']);
  }

  onDebugIdChanged(debugId: string | null) {
    this.debugId = debugId;
  }

  goToDebug() {
    if (!this.debugId) return;
    this.router.navigate(['/debug', this.debugId]);
  }

  logout(): void {
    this.auth
      .logout({
        logoutParams: {
          returnTo: window.location.origin,
        },
      })
      .subscribe();
  }
}

